import RetailApiClient from '@/api/RetailApiClient';

// 5 minutes
const ESTIMATE_TTL_MS = 5 * 60 * 1000;

export default {
  namespaced: true,
  state: {
    estimatesByKey: {},
  },
  mutations: {
    setRetailEstimate(state, { key, estimate }) {
      state.estimatesByKey = {
        ...state.estimatesByKey,
        [key]: { estimate, expires: Date.now() + ESTIMATE_TTL_MS },
      };
    },
  },
  actions: {
    // estimatesByKey entries are never evicted on their own - expired entries
    // are only skipped here and then overwritten by the next successful fetch.
    async fetchRetailPrice({ commit, state }, { vin, odometer, zip }) {
      const key = `${vin}-${odometer}-${zip}`;
      const existingEntry = state.estimatesByKey[key];
      if (existingEntry?.expires > Date.now()) {
        return existingEntry.estimate;
      }

      const client = new RetailApiClient();
      const estimate = await client.fetchRetailPrice({ vin, odometer, zip });
      commit('setRetailEstimate', { key, estimate });
      return estimate;
    },
  },
};
